var base = require('auth/register-stripe');

Spark.forms.register = {
    phone		: null,
    region		: null,
    postalCode	: null,
    isoCountry	: null,
};

Vue.component('spark-register-stripe', {
    mixins: [base],

    updated() {
        if (this.invitation) {
            this.registerForm.name  = this.invitation.name;
            this.registerForm.email = this.invitation.email;
        }
    },

    methods: {
        selectPlan(plan) {
            this.selectedPlan = plan;
            this.registerForm.plan = plan.id;
        },
    }
})
